import PhoneInputComponent, { type Country } from 'react-phone-number-input';
import { Controller, useFormContext, get } from 'react-hook-form';
import { useTranslation } from "next-i18next";
import cx from "classnames";

import { Stack } from "../Stack";
import { ErrorDisplay } from "../ErrorDisplay";
import { Icon } from "../Icon";

import 'react-phone-number-input/style.css';
import styles from "./PhoneInput.module.scss";

export interface PhoneInputProps {
  label?: string,
  name: string,
  readOnly?: boolean,
  disabled?: boolean,
  defaultCountry?: Country,
  className?: string,
  labelClassName?: string,
  required?: boolean,
}

export function PhoneInput({
  label,
  name,
  readOnly,
  disabled,
  defaultCountry = "CA",
  className,
  labelClassName,
  required,
}: PhoneInputProps) {
  const { t } = useTranslation("validation");
  const { formState: { errors }} = useFormContext();

  const error = get(errors, name);

  return (
    <Stack direction='column' gap={4}>
      {label && (
        <label
          className={cx(styles.Label, labelClassName)}
          htmlFor={name}
        >
          {label}
          {required && <span className={styles.Required}>*</span>}
        </label>
      )}
      <Controller
        name={name}
        render={({ field }) => (
          <div className={styles.PhoneInput}>
            <PhoneInputComponent
              id={name}
              readOnly={readOnly}
              disabled={disabled}
              defaultCountry={defaultCountry}
              required={required}
              numberInputProps={{
                className: cx(styles.NumberInput, className, {
                  [styles.error]: error,
                }),
              }}
              {...field}
            />
            {readOnly && (
              <Icon
                className={styles.LockIcon}
                icon='lock'
              />
            )}
          </div>
        )}
      />
      {error && (
        <ErrorDisplay error={t(error.message)} />
      )}
    </Stack>
  )
}
